exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box-aest{padding-bottom:-10%}.renewal-header{position:fixed;top:3.5rem;left:0;right:0;margin:inherit;z-index:1020}.renewal-header~.app-body{padding-top:7rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-67b9ee56","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/franchise_component/subscription-renewal/almost-expiry-announcement.vue
// module id = dMX8
// module chunks = 113